import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/oraya-api";
import { useCommand } from "@/context/CommandContext";
import { Panel, Field, inputCls, CCButton, LoadingState } from "@/command/ccUi";

const FIELDS = [
  ["public_brand", "Public Brand"], ["legal_name", "Legal Name"], ["cin", "CIN"], ["pan", "PAN"],
  ["gstin", "GSTIN"], ["incorporation_date", "Incorporation Date"], ["industry", "Industry"],
  ["corporate_email", "Corporate Email"], ["phone", "Phone"], ["website", "Website"],
  ["registered_address", "Registered Address"], ["description", "Description"],
];

export default function Company() {
  const { can } = useCommand();
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);
  const editable = can("company", "MANAGE");

  useEffect(() => { api.get("/cc/company").then(({ data }) => setForm(data || {})).catch(() => setForm({})); }, []);

  const save = async () => {
    setSaving(true);
    try { await api.put("/cc/company", form); toast.success("Company profile saved"); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setSaving(false); }
  };

  if (!form) return <LoadingState />;

  return (
    <div className="max-w-3xl">
      <h1 className="display text-2xl md:text-3xl font-light text-ink">Company</h1>
      <p className="text-subtle mt-1 mb-8">Corporate profile & legal information. The public brand is <b>ORAYA</b>.</p>

      <Panel testid="company-panel">
        <div className="grid sm:grid-cols-2 gap-5">
          {FIELDS.map(([k, label]) => (
            <div key={k} className={k === "registered_address" || k === "description" ? "sm:col-span-2" : ""}>
              <Field label={label}>
                {k === "description" || k === "registered_address" ? (
                  <textarea className={`${inputCls} resize-y`} rows={2} value={form[k] || ""} disabled={!editable} onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`company-${k}`} />
                ) : (
                  <input className={inputCls} value={form[k] || ""} disabled={!editable} onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`company-${k}`} />
                )}
              </Field>
            </div>
          ))}
        </div>
        {editable && <div className="mt-6"><CCButton onClick={save} disabled={saving} testid="company-save">{saving ? "Saving…" : "Save changes"}</CCButton></div>}
      </Panel>
    </div>
  );
}
